<script setup lang="ts">
import { useId } from 'vue'

/**
 * Elfie's face (Dao, 1 Oct 2026): brand artwork, like the coin, the same in
 * both themes. It blinks now and then, unless the reader asked for less
 * motion. Sized by its container.
 */
// Its own gradient id: two faces on a page must not share one.
const gradient = useId()
</script>

<template>
  <svg viewBox="0 0 64 64" aria-hidden="true" focusable="false">
    <defs>
      <radialGradient :id="gradient" cx="38%" cy="30%" r="75%">
        <stop offset="0%" class="face__glow" />
        <stop offset="100%" class="face__deep" />
      </radialGradient>
    </defs>
    <circle cx="32" cy="32" r="31" class="face__ring" />
    <circle cx="32" cy="32" r="25" :fill="`url(#${gradient})`" />
    <g class="face__eyes">
      <ellipse cx="24.5" cy="30" rx="3.6" ry="5.4" />
      <ellipse cx="39.5" cy="30" rx="3.6" ry="5.4" />
    </g>
    <path d="M28.5 40.5 q3.5 3 7 0" class="face__smile" />
  </svg>
</template>

<style scoped>
svg {
  display: block;
  inline-size: 100%;
  block-size: 100%;
}

/* Brand artwork, like the coin: the same in both themes. */
.face__ring {
  fill: var(--companion-ring);
}

.face__glow {
  stop-color: var(--companion-glow);
}

.face__deep {
  stop-color: var(--companion-face);
}

.face__eyes {
  fill: var(--companion-eye);
  transform-origin: 32px 30px;
  animation: blink 5s infinite;
}

.face__smile {
  fill: none;
  stroke: var(--companion-eye);
  stroke-width: 2.4;
  stroke-linecap: round;
}

@keyframes blink {
  0%,
  94%,
  100% {
    transform: scaleY(1);
  }

  97% {
    transform: scaleY(0.1);
  }
}

@media (prefers-reduced-motion: reduce) {
  .face__eyes {
    animation: none;
  }
}
</style>
